import { ChangeDetectionStrategy, Component, ElementRef, Input } from "@angular/core";
import { TranslatedString } from 'models/translated-string';

@Component({
    selector: 'cs-fab-button',
    templateUrl: 'cs-fab-button.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsFabButtonComponent {

  @Input() icon?: string;
  @Input() label?: TranslatedString;
  @Input() disabled?: boolean;

  constructor(public elementRef: ElementRef) {

  }

  handleClick(event: Event) {
    void event;
  }
}